import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ConcurrentLabelsAPI from '../../api/concurrentLabels';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CONCURRENT_LABEL_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getConcurrentLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getConcurrentLabelsOnSidebar(_state) {
    return _state.records
      .filter(record => record.show_on_sidebar)
      .sort((a, b) => a.title.localeCompare(b.title));
  },
};

export const actions = {
  revalidate: async function revalidate({ commit }, { newKey }) {
    try {
      const isExistingKeyValid = await ConcurrentLabelsAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await ConcurrentLabelsAPI.refetchAndCommit(newKey);
        commit(types.SET_CONCURRENT_LABELS, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },

  get: async function getConcurrentLabels({ commit }) {
    commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isFetching: true });
    try {
      const response = await ConcurrentLabelsAPI.get(true);
      commit(types.SET_CONCURRENT_LABELS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createConcurrentLabels({ commit }, payload) {
    commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isCreating: true });
    try {
      const response = await ConcurrentLabelsAPI.create(payload);
      AnalyticsHelper.track(CONCURRENT_LABEL_EVENTS.CREATE);
      commit(types.ADD_CONCURRENT_LABEL, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateConcurrentLabels({ commit }, { id, ...updateObj }) {
    commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await ConcurrentLabelsAPI.update(id, updateObj);
      AnalyticsHelper.track(CONCURRENT_LABEL_EVENTS.UPDATE);
      commit(types.EDIT_CONCURRENT_LABEL, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteConcurrentLabels({ commit }, id) {
    commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isDeleting: true });
    try {
      await ConcurrentLabelsAPI.delete(id);
      AnalyticsHelper.track(CONCURRENT_LABEL_EVENTS.DELETED);
      commit(types.DELETE_CONCURRENT_LABEL, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONCURRENT_LABEL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONCURRENT_LABEL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONCURRENT_LABELS]: MutationHelpers.set,
  [types.ADD_CONCURRENT_LABEL]: MutationHelpers.create,
  [types.EDIT_CONCURRENT_LABEL]: MutationHelpers.update,
  [types.DELETE_CONCURRENT_LABEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

